import type { UnionReservation } from "@/api/business/types/table"

export const RESERVATION_OPEN_TABLE_TYPE = "RESERVATION"
export const RESERVATION_OPEN_TABLE_STALE_MESSAGE = "预订信息已刷新，请重新打开预订后再开台"

export interface ReservationOpenTableContext {
  openTableType: typeof RESERVATION_OPEN_TABLE_TYPE
  reserveId: number
  merchantUserId?: number
}

function toPositiveId(value: unknown) {
  const id = Number(value)
  return Number.isFinite(id) && id > 0 ? id : undefined
}

function firstArrayItem(value: unknown) {
  return Array.isArray(value) ? value[0] : value
}

export function getReservationReservedTableId(reservationInfo?: Partial<UnionReservation> | null) {
  if (!reservationInfo) {
    return undefined
  }

  if ("reserveTableId" in reservationInfo) {
    const reserveTable = firstArrayItem(reservationInfo.reserveTableId)
    if (typeof reserveTable === "object" && reserveTable !== null && "tableId" in reserveTable) {
      return toPositiveId(reserveTable.tableId)
    }
    return toPositiveId(reserveTable)
  }

  if ("tableId" in reservationInfo) {
    return toPositiveId(reservationInfo.tableId)
  }

  return undefined
}

export function getReservationOpenTableContext(reservationInfo?: Partial<UnionReservation> | null): ReservationOpenTableContext | undefined {
  if (!reservationInfo || !("reserveId" in reservationInfo)) {
    return undefined
  }

  const reserveId = toPositiveId(firstArrayItem(reservationInfo.reserveId))
  if (!reserveId) {
    return undefined
  }

  const merchantUserId = "merchantUserId" in reservationInfo
    ? toPositiveId(reservationInfo.merchantUserId)
    : undefined

  return {
    openTableType: RESERVATION_OPEN_TABLE_TYPE,
    reserveId,
    merchantUserId,
  }
}
